<autocomplete-list-item (clicked)="triggerEvent()">
  {{ item.name }}{{ item.ikNumber ? ', ' : '' }}{{ item.ikNumber }}
</autocomplete-list-item>
